import { render } from "./CapitalModalRWA.vue?vue&type=template&id=393c14f2&scoped=true"
import script from "./CapitalModalRWA.vue?vue&type=script&lang=js"
export * from "./CapitalModalRWA.vue?vue&type=script&lang=js"

import "./CapitalModalRWA.vue?vue&type=style&index=0&id=393c14f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393c14f2"]])

export default __exports__